import { QueueHandler } from './QueueHandler'

export default new QueueHandler()
export * from './index.types'
